import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IspisPlanaService {
  constructor(private _http: HttpClient) {}

  ispisPlana(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'ispisplana_prikaz', a)
      .pipe(map((res: any) => res));
  }

  ispisPlanaNovi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'ispisplana_prikaz_novi_nacin', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLinije(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSkladista(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_skladista_pekar', a)
      .pipe(map((res: any) => res));
  }

  pogoni(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'pogoni', a)
      .pipe(map((res: any) => res));
  }
}
